import sportsjam from "../image/sportsjam.png";
import freshmenu from "../image/freshmenu.png";
import nordstrom from "../image/nordstrom.png";
import netmeds from "../image/netmeds.png";


import {BsBoxArrowInRight} from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";


export const GroupProjects = () => {
     
    
    const seeLink = (link) => {
        window.open(link, `_blank`);
    }


    return (
        <div className="projectShow_div">
                



                <div data-aos="flip-right"  className="projectDiv">
                    <img src={sportsjam} className="project_img" alt="" />
                    <div>
                        <h4>SportsJam.in Clone <FaGithub onClick={()=> seeLink(`https://github.com/sreerag-rajan/sportsjam-clone`)} className="gitLogo"/></h4>
                        <p>An ecommerce website for sports goods. It contains fully responsive homepage, product page, beautiful css animations along with javascript functionalities</p>
                        <div className="projectBtn_div">
                            <button onClick={()=> seeLink(`https://medium.com/@sreerag.rajan5/cloning-sportsjam-in-cd1c80c1b06b`)}>Know More</button>
                            <button onClick={()=> seeLink(`https://practical-meninsky-36f305.netlify.app/`)}>See Live</button>
                        </div>

                    </div>
                </div>
                <div data-aos="flip-left"  className="projectDiv">
                    <img src={freshmenu} className="project_img" alt="" />
                    <div>
                        <h4>Freshmenu.com Clone <FaGithub onClick={()=> seeLink(`https://github.com/Neha-251/freshmenu-project`)} className="gitLogo"/></h4>
                        <p>A food website. Features: responsive home page, use of API, responsive cart page, Location tracking facility in payment page.</p>
                        <div className="projectBtn_div">
                            <button onClick={()=> seeLink(`https://medium.com/@neha712513/cloning-freshmenu-com-775071164e20`)}>Know More</button>
                            <button onClick={()=> seeLink(`https://ecstatic-newton-d846b4.netlify.app/`)}>See Live</button>
                        </div>
                    </div>

                </div>
              
                <div data-aos="flip-left" className="projectDiv">
                    <img src={nordstrom} className="project_img" alt="" />
                    <div>
                        <h4>Nordstrom.com Clone <FaGithub onClick={()=> seeLink(`https://github.com/sharanweb/Nordstorm-Clone`)} className="gitLogo"/></h4>
                        <p>An American luxury department store chain. Features: made cart, checkout, productpage filter with Backend.</p>


                        <div className="projectBtn_div">
                            <button onClick={()=> seeLink(`https://medium.com/@neha712513/nordstrom-com-clone-862a5593fc65`)}>Know More</button>
                            <button onClick={()=> seeLink(`https://nordstormunit4.netlify.app/`)}>See Live</button>
                        </div>
                    </div>

                </div>
                <div data-aos="flip-right" className="projectDiv">
                    <img src={netmeds} className="project_img" alt="Netmeds.com" />
                    <div>
                        <h4>Netmeds.com Clone <FaGithub onClick={()=> seeLink(`https://github.com/Neha-251/Netmeds-Clone.git`)} className="gitLogo"/></h4>
                        <p>Netmeds.com is an Indian Online Pharmacy. Key Features: User based experience in whole application. applying coupons for different discounts.
                            Wide use of Backend and its integration with Frontend.
                        </p>


                        <div className="projectBtn_div">
                            <button onClick={()=> seeLink(`https://medium.com/@neha712513/nordstrom-com-clone-862a5593fc65`)}>Know More</button>
                            <button onClick={()=> seeLink(`https://netmeds-clone-phi.vercel.app/`)}>See Live</button>
                        </div>
                    </div>

                </div>

            
            </div>
    )
}